import { curryN, all, any, complement, ifElse, converge, times, always, nthArg, pipe, divide, multiply, flip, add, mean, median, modulo, subtract, gt, gte, lt, lte } from 'ramda';
import { stubNull, isTrue, isFalse, mapIndexed, lengthGt, isNilOrEmpty } from 'ramda-adjunct';

// Ramdas math methods are not pipeable
// i.e. r.subtract(1)(5) is not 4, it's -4
// so we export some pipeable version of these methods
var add$1 = flip(add);
var divide$1 = flip(divide);
var mean$1 = flip(mean);
var median$1 = flip(median);
var modulo$1 = flip(modulo);
var multiply$1 = multiply;
var subtract$1 = flip(subtract);
var gt$1 = flip(gt);
var gte$1 = flip(gte);
var lt$1 = flip(lt);
var lte$1 = flip(lte);

var curry1 = curryN(1);
var curry2 = curryN(2);
var curry3 = curryN(3);
var curry4 = curryN(4);

var nuller = stubNull;
var isTrue$1 = isTrue;
var isFalse$1 = isFalse;
var mapIndexed$1 = mapIndexed;

var allTrue = all(isTrue$1);

var allFalse = all(isFalse$1);

var anyTrue = any(isTrue$1);

var anyFalse = any(isTrue$1);

var hasLength = lengthGt(0);

var isNotNilOrEmpty = complement(isNilOrEmpty);

var ifElseBool = ifElse(isTrue$1);

var arrayOf = curry2(converge(times, [always, nthArg(1)]));

var percentage = pipe(divide, multiply(100));

export { curry1, curry2, curry3, curry4, nuller, isTrue$1 as isTrue, isFalse$1 as isFalse, mapIndexed$1 as mapIndexed, allTrue, allFalse, anyTrue, anyFalse, hasLength, isNotNilOrEmpty, ifElseBool, arrayOf, percentage, add$1 as add, divide$1 as divide, mean$1 as mean, median$1 as median, modulo$1 as modulo, multiply$1 as multiply, subtract$1 as subtract, gt$1 as gt, gte$1 as gte, lt$1 as lt, lte$1 as lte };
